import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  setup() {
    return {
      locale: zhCn
    };
  }

};